import { AUTH_TYPE } from '../../infrastructure/enums/authentication.enum'

export const authTypeGuard = (type: string | null): type is AUTH_TYPE => {
  return type === AUTH_TYPE.EXTERNAL || type === AUTH_TYPE.INTERNAL
}
